import {checkSectionVisibility} from '../Common/checkSectionVisibility';

export function populateLife(jsonData){
    lifeData = jsonData;
    console.log("jsonData: ",jsonData);
    
    lifeHeadingText = jsonData.life.section_heading.value;

    lifeTabs = jsonData.life.data.tabs.names;

    saveLifeTabs = jsonData.life.data.tabs.names;
    
    if(!$(document).find(".preview").hasClass("hidden")){
        $("#lifeHeadingText").html(lifeHeadingText);        
    }
    else{ 
        checkSectionVisibility(jsonData.life.visibility, $(".life"));                           
        $("input#lifeHeadingText").val(lifeHeadingText);
    }
    
    function getTabs() {
        var member = $('.category.prototype.hidden').clone().removeClass('prototype hidden');
        member.addClass("categoryList");
        return {
            element: member,
            tabName: member.find(".life_nav_input"),
        }
    }
    var count = 0;
    function populateTabs(){

        if(lifeTabs.length > 1){            
            $('.life__navigation-area').find("ul").removeClass("hidden")
        }
        
        $.each(lifeTabs, function(index, item) {
            if(count< lifeTabs.length){
                var newTab = getTabs();
                if(!$(document).find(".preview").hasClass("hidden")){
                    newTab.tabName.html(item.tabName); 
                    newTab.element.css("margin","0 25px");       
                }
                else{                            
                    newTab.tabName.val(item.tabName);
                    if(count>=1){                    
                        newTab.element.find(".removeLifeTab").removeClass("hidden");
                    }
                }
                if(count == 0){
                    newTab.element.addClass("active");
                }
                
                newTab.element.attr('data-id', count);
                $('.life__navigation-area').find("ul").append(newTab.element);
                count++;
            }
        });          
    }

    function addDynamicLifeTab(){
        var newTab = getTabs();
        newTab.element.attr('data-id', count);
        newTab.element.find(".removeLifeTab").removeClass("hidden");        
        saveCurrentImages();
        $('li').removeClass('active');
        newTab.element.addClass("active");        

        $('.life__navigation-area').find("ul").append(newTab.element);
        newTab.element.css("background-color", "#cbe4ff");
        window.setTimeout(function(){
            newTab.element.css("background-color", "initial"); 
        }, 1000);
        
    }

    $(".addLifeMenuTab").on('click', function(){        
        if(count<jsonData.life.data.tabs.maximum){
            if($('.life__navigation-area').find("ul").hasClass("hidden")){
                $('.life__navigation-area').find("ul").removeClass("hidden")
            }
            addDynamicLifeTab();
            lifeTabs.push(
                {
                    "tabName": "",
                    "images": [
                        pageUrl + "/static/images/life_1.jpg",
                        pageUrl + "/static/images/life_2.jpg",
                        pageUrl + "/static/images/life_3.jpg",
                        pageUrl + "/static/images/life_4.jpg",
                        pageUrl + "/static/images/life_5.jpg"
                    ]
                }
            )
            // console.log("added", lifeTabs); 
            // console.log(count);
            
            
            populateImages(count);  
            count++     
             
             
        }
        else{
            toastNotify(3,"You have acheived the maximum limit.");
        }
    });

    $("#lifeMenu").on('click', ".removeLifeTab" ,function(){          
        $(this).parent().remove();
        // console.log($(this).parent());
        
        // console.log($(this).parent().attr('data-id'));
        removeIndex = $(this).parent().attr('data-id');
        
        lifeTabs.splice(removeIndex ,1)
        // console.log("removed", lifeTabs);
        
        count--;  
        
        if(count == 1){
            $('.life__navigation-area').find("ul").addClass("hidden");
        }

        $("li.categoryList").each(function(index){
            // console.log("assign");
            
            $(this).attr('data-id', index);
        });    


        populateImages(removeIndex-1);
        $('li').removeClass('active');
        $("li.categoryList[data-id="+(removeIndex-1) +"]").addClass("active");

    });

    function populateImages(categoryId){        
        $.each(lifeTabs[categoryId].images, function(index, imagePath){              
            var getImageElement = $('.life__grid').find('.life__image[data-id='+index+']');              
            getImageElement.attr('src', imagePath);
            getImageElement.attr('data-src', imagePath);

            if(imagePath.indexOf('_cropped')> -1){
                getImageElement.attr('data-original-src', imagePath.split('_cropped')[0] + '.jpg')       
            }
            else{
                getImageElement.attr('data-original-src', imagePath)
            }

            if(!$(document).find(".preview").hasClass("hidden")){
                $(".life__grid").find("img").css("cursor", "default");        
            }
        });
    }

    function populateData(jsonData){
        populateTabs();
        populateImages(0);
    }

    populateData(jsonData);   

    // function isActive() {
        $('#lifeMenu').on('click', '.life_nav_input', function() {

            saveCurrentImages();
            
            $('li').removeClass('active');
            $(this).parent().addClass('active');
            categoryId = $(this).parent().attr('data-id');
               
            populateImages(categoryId);
        })
    // }

    function saveCurrentImages(){
        if(!$(document).find(".preview").hasClass("hidden")){       
        }
        else{                 
            var getListElement = $("ul#lifeMenu").find("li.active");

            var imageArray = [];
            var saveImageArray = [];

            $(".life__image").each(function(index,el){
                imageArray.push($(el).attr("src"));
                saveImageArray.push($(el).attr("data-src"));
            }); 
                        
            lifeTabs[getListElement.attr('data-id')] = {
                tabName: getListElement.find("input.life_nav_input").val(),
                images: imageArray
            }
            
            saveLifeTabs[getListElement.attr('data-id')] = {
                tabName: getListElement.find("input.life_nav_input").val(),
                images: saveImageArray
            }                           
        }
    }
    function showMoreImages(){
        var showMoreContainer = $(".show-more-container.lifeMore");
        var showMoreButton = showMoreContainer.find("button");
        showMoreButton.append("<i class='icon-down_arrow'></i>");

        showMoreButton.on('click', function(){
            if($(".see-more").hasClass("hidden")){
                $(".see-more").removeClass("hidden");
                showMoreButton.html("See Less");
                showMoreButton.append("<i class='icon-top_arrow'></i>");
            }
            else{
                $(".see-more").addClass("hidden");
                showMoreButton.html("See More");
                showMoreButton.append("<i class='icon-down_arrow'></i>");
            }
        });

    }
    if(!$(document).find(".preview").hasClass("hidden")){
        showMoreImages();
    }
    
}
